import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "storeCards mb-2" }
const _hoisted_2 = { class: "closestStore" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "closest-store-text mb-4" }, "Your nearest pickup store:", -1)
const _hoisted_4 = { class: "other-stores-text" }
const _hoisted_5 = {
  key: 1,
  class: "zipFlyout-information-divider my-4"
}
const _hoisted_6 = { class: "all-stores-selection" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "arrow-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DealershipCard = _resolveComponent("DealershipCard")!
  const _component_sc_text = _resolveComponent("sc-text")!
  const _component_sc_image = _resolveComponent("sc-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.dealerships)
        ? (_openBlock(), _createBlock(_component_DealershipCard, {
            key: 0,
            fields: _ctx.fields,
            dealership: _ctx.closestDealership,
            directionsOrigin: _ctx.zipCode
          }, null, 8, ["fields", "dealership", "directionsOrigin"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_sc_text, {
        field: _ctx.fields?.otherStoreDescription
      }, null, 8, ["field"])
    ]),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (index) => {
      return _createElementVNode("div", {
        key: index,
        class: "dealer-cards-wrapper"
      }, [
        (_ctx.dealerships)
          ? (_openBlock(), _createBlock(_component_DealershipCard, {
              key: 0,
              fields: _ctx.fields,
              dealership: _ctx.dealerships[index],
              directionsOrigin: _ctx.zipCode
            }, null, 8, ["fields", "dealership", "directionsOrigin"]))
          : _createCommentVNode("", true),
        (index < 2)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5))
          : _createCommentVNode("", true)
      ])
    }), 64)),
    _createElementVNode("div", {
      class: _normalizeClass(["div-loading flyoutLoader", { 'd-block': _ctx.loading }])
    }, null, 2),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("a", {
        class: "all-stores-link",
        href: _ctx.fields?.allStoresLink.value,
        target: "_BLANK"
      }, [
        _createVNode(_component_sc_text, {
          field: _ctx.fields?.allStoresDescription
        }, null, 8, ["field"])
      ], 8, _hoisted_7),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_sc_image, {
          media: _ctx.fields?.allStoresIcon
        }, null, 8, ["media"])
      ])
    ])
  ]))
}